import { ElasticSearchService, ESExtras, EsFirestoreBase, objectToArr } from '@a2system/angular';
import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { collection, collectionData, doc, docData, Firestore, limit, query, runTransaction, where } from '@angular/fire/firestore';
import { environment } from 'admin/src/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

const ES_EXTRA:ESExtras = {

}

const ES_SOURCE = null; //['status']

@Injectable({
  providedIn: 'root'
})


export class SettingDsService extends EsFirestoreBase<any> {
  collectionName = 'settings';
  constructor(
    @Optional() protected firestore: Firestore,
    protected es: ElasticSearchService,
    private http: HttpClient
  ) {
    super(firestore, es, 'settings', ES_EXTRA, ES_SOURCE);

  }

  getPathAll$(path):Observable<any[]> {
    const _collection = collection(this.firestore, `${this.collectionName}/${path}`).withConverter(this.genericConverter);
    const _query = query(_collection, limit(100))
    return collectionData(_query, {idField:'id'}) as Observable<any[]>;
  }

  nextCount = (counter) => {
    const docRef = doc(this.firestore, this.collectionName, 'counters');

    return runTransaction(this.firestore, async (transaction) => {
      const countersDoc = await transaction.get(docRef);
      const newCounterValue = countersDoc.data()[counter] + 1;
      transaction.update(docRef, { [counter]: newCounterValue });
      return newCounterValue;
    })
  }

  nextSN = () =>{
    const docRef = doc(this.firestore, this.collectionName, 'counters');

    return runTransaction(this.firestore, async (transaction) => {
      const countersDoc = await transaction.get(docRef);
      const currentYear = new Date().getFullYear();
      const isNewYear = currentYear != countersDoc.data()['year'];
      const windows = isNewYear ? 0 : countersDoc.data()['windows'] + 1;
      const year = isNewYear ? currentYear : countersDoc.data()['year'];
      transaction.update(docRef, {windows, year });
      return {windows, year};
    })    
  }

  getWindowStudies$(options){
    const {brand, serie} = options;
    const _collection = collection(this.firestore, `${this.collectionName}/specifications/windowStudies`).withConverter(this.genericConverter);
    const _query = query(_collection, where('brand.id' ,'==', brand.id), where('serie.id','==',serie.id), limit(100))
    return collectionData(_query, {idField:'id'}).pipe(
      map(windowStudy=>windowStudy
        .map(study=>(
          {
            ...study,
            studies: study.studies.map(study=>(
              {...study, conditions:study.conditions.map(condition => objectToArr(condition))}
            ))        
          }        
        ))
        .sort((a,b)=>a.versions?.length * -1)
      ),
      shareReplay(1)      
    ) as Observable<any[]>;
  }

  async getDynamicLink(urlSuffix, queryParams=null){
    // const firebaseDynamicLinks = new FirebaseDynamicLinks(environment.firebaseConfig.apiKey);
    const baseUrl = environment.appLink;
    const docRef = doc(this.firestore, this.collectionName, 'dynamicLinks');
    const dynamicLinks = await firstValueFrom(docData(docRef));
    const link = `${baseUrl}${urlSuffix}?${ queryParams ? queryParams : ''}`;

    // console.log("Link", link);

    return firstValueFrom(
      this.http.post<any>(`https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${environment.firebaseConfig.apiKey}`,
        {
          dynamicLinkInfo: {
            domainUriPrefix: dynamicLinks.domainUriPrefix,
            link: link,
            socialMetaTagInfo: dynamicLinks.socialMetaTagInfo,
          },
          suffix: {
            option: dynamicLinks.suffixOption
          }
        }
      )
    )
  }

  createId(){
    return doc(collection(this.firestore, 'id')).id;
     //.createId();
   }

}
